module.exports = __webpack_public_path__ + "media/images/responsive/page_common/search_icons/dress-80b9c930799ad406d31ddea89fcc9d21.svg";